import React from 'react';
import { smoothScroll } from '../../utils/smoothScroll';
import './Navbar.css';

const Navbar = () => {
  const handleScroll = (e, targetId) => {
    e.preventDefault();
    smoothScroll(targetId);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <a href="#home" onClick={(e) => handleScroll(e, '#home')}>Dra. Walquiria Ramirez</a>
      </div>
      <div className="navbar-links">
        <a href="#home" onClick={(e) => handleScroll(e, '#home')}>Inicio</a>
        <a href="#consult" onClick={(e) => handleScroll(e, '#consult')}>Cuándo consultar</a>
        <a href="#booking" onClick={(e) => handleScroll(e, '#booking')}>Pedir turno</a>
        <a href="#about" onClick={(e) => handleScroll(e, '#about')}>Sobre Mi</a>
      </div>
    </nav>
  );
};

export default Navbar;
